<template>
    <div class="pipetable">
        <el-tabs v-model="activeName" class="pipetable-wrap" >
            <el-tab-pane :label="item.title" :name="item.name" v-for="item in tabPanel" :key="item.name">
                <el-table :data="item.features" border style="width: 100%" class="custom-table"
                        header-row-class-name="custom-header"
                        row-class-name="custom-row"
                        max-height="400"
                        cell-class-name="custom-cell">

                    <!--显示id号-->
                    <el-table-column label="ID" width="40">
                        <template slot-scope="scope">
                            {{scope.row.get("id")?scope.row.get("id"):'0'}}
                        </template>
                    </el-table-column>

                    <!--显示其他字段-->
                    <el-table-column v-for="field in item.fields" :key="field.name" :label="field.title">
                        <template slot-scope="scope">
                            {{scope.row.get(field.name)?scope.row.get(field.name):field.default}}
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleEdit(scope.row,scope.$index)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="handleDelete(scope.row,scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </el-tab-pane>
        </el-tabs>



    </div>
</template>

<script>
/**
 * 管道编辑表格
 */
import { mapState } from 'vuex';

export default {
    name:"simulationtable",
    props:['nodeinfos','pipeinfos'],
    computed:{
        ...mapState('simulation',[
            'globalSet',
            'drawSource', // 绘图图层
            'simutype', // 当前介质类型
            'globalConfig', // 全局配置内容
        ]),
    },
    data(){
        return {
            activeName:"node", // 显示面板
            tabPanel:null, // 面板
        }
    },
    watch:{
        globalSet:{
            handler(){
                this.init_data();
            },
            deep:true
        }
    },
    mounted(){
        this.init_data();
    },
    methods:{
        // 初始化数据
        init_data(){
            // 初始化面板
            let tempTabPanel={};
            let fieldSet=this.globalConfig.fieldSet;
            for(let fieldName in fieldSet){
                let field=fieldSet[fieldName];
                let _type=field._type;
                if(field.simutype.indexOf(this.simutype)>=0||!field.simutype){
                    tempTabPanel[_type]=field; // 生成当前页面需要的字段列表
                    tempTabPanel[_type].features=[]; // 初始化空的数组列表
                }
            }
            // 初始化数据
            let features=this.drawSource.getFeatures();
            features.forEach(f=>{
                let _type=f.get("_type");
                if(tempTabPanel[_type]){ // 定义了特别的节点
                    tempTabPanel[_type].features.push(f);
                }else{// 如果没有定义相关的节点类型，则需要放到通用节点列表里面
                    tempTabPanel.common.features.push(f);
                }

            });
            // 显示第一个   
            this.activeName=tempTabPanel[Object.keys(tempTabPanel)[0]].name;
            this.tabPanel=tempTabPanel;
        },
        // 编辑要素
        handleEdit(feature){
            // 选中要素
            this.$store.commit("simulation/setCurFeatures",[feature]);
            // 触发属性编辑
            this.$bus.$emit("editProperies",feature);
        },
        // 删除要素
        handleDelete(){
            this.$bus.$emit("delected");
        }
    }
}
</script>

<style lang="scss" scoped>
.pipetable{
    width: 700px;
    .menu{
        text-align: right;
        margin-top: 5px;
    }
}
</style>